import React from "react";
import { GeoJSON } from "react-leaflet";

const LinkedBorders = ({ countries }) => {
  const onEachCountryLabel = (labelText) => (feature, layer) => {
    const name = feature.properties?.ADMIN || labelText;
    if (name && name !== "Countries") {
      layer.bindTooltip(name, {
        permanent: true,
        direction: "center",
        className: "country-label",
      });
    }
  };

  return countries.map((country, index) => (
    <GeoJSON
      key={index}
      data={country.data}
      style={{
        color: country.color,
        weight: 1,
        fillOpacity: 0.3,
      }}
      onEachFeature={onEachCountryLabel(country.name)}
    />
  ));
};

export default LinkedBorders;